// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2zt5z","log":"ModalInventoryLogs_log__13oOb","date":"ModalInventoryLogs_date__10dxb","userName":"ModalInventoryLogs_userName__2UWko"};